<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align: center">
<img alt="Cover" class="x-ebookmaker-cover" src="cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wrap0000.vue?50ae5df6